import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=fb8ee5c4"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"
import style0 from "./Training.vue?vue&type=style&index=0&id=fb8ee5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports